import { useEffect } from "react";

import ImageUpload from "../inputs/ImageUpload";

const ALLOWED_IMG_MIME_TYPES = /image\/(png|jpg|jpeg)/i;
const EventImagesUpload = ({ setFormData, formData, fileInputName }) => {
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    const name = e.target.name;

    if (file) {
      if (!file.type.match(ALLOWED_IMG_MIME_TYPES)) {
        alert("File is not an allowed image type.");
        return;
      }

      setFormData((prevState) => ({
        ...prevState,
        [name]: file,
      }));
    } else {
      const relevantProperties =
        fileInputName === "bannerFile"
          ? { bannerFile: null, bannerData: null }
          : {
              imageFile: null,
              imageData: null,
            };
      setFormData((prevState) => ({
        ...prevState,
        ...relevantProperties,
      }));
    }
  };

  useEffect(() => {
    let reader,
      isCancel = false;
    const file = formData[fileInputName];

    if (file) {
      reader = new FileReader();
      reader.onload = (e) => {
        const { result } = e.target;
        if (result && !isCancel) {
          const keyName =
            fileInputName === "bannerFile" ? "bannerData" : "imageData";
          setFormData((prevState) => ({
            ...prevState,
            [keyName]: result,
          }));
        }
      };
      reader.readAsDataURL(file);
    }

    return () => {
      isCancel = true;
      if (reader && reader.readyState === 1) {
        reader.abort();
      }
    };
  }, [fileInputName, formData[fileInputName]]);

  return <ImageUpload name={fileInputName} onFileChange={handleFileChange} />;
};

export default EventImagesUpload;
